import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { FlexibleTextArea } from 'UI/Inputs';
import '../../Verdict.scss';

var VerdictFeedbackForm = /*#__PURE__*/function (_Component) {
  _inherits(VerdictFeedbackForm, _Component);

  var _super = _createSuper(VerdictFeedbackForm);

  function VerdictFeedbackForm(props) {
    var _this;

    _classCallCheck(this, VerdictFeedbackForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      var value = event.target.value;

      _this.setState({
        value: value
      }, function () {
        if (_this.props.onChange != null) {
          _this.props.onChange(value);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.value != _this.state.value) {
        _this.setState({
          value: nextProps.value
        });
      }
    });

    var _value = '';

    if (props.value != null) {
      _value = props.value;
    }

    _this.state = {
      value: _value
    };
    return _this;
  }

  _createClass(VerdictFeedbackForm, [{
    key: "render",
    value: function render() {
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-feedback-form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          padding: 0
        }
      }, /*#__PURE__*/React.createElement(FlexibleTextArea, {
        value: this.state.value != null ? this.state.value : '',
        placeholder: translate('write-feedback'),
        onChange: this.onChange
      })))));
    }
  }]);

  return VerdictFeedbackForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(VerdictFeedbackForm);